export enum ConversationInquiryStatusEnum {
  UNRESOLVED = 1, //未対応
  PROCESSING = 2, //対応中
  INQUIRY_CLOSED = 3, //お問い合わせ終了
}

export const ConversationInquiryStatusText = (type: number): string => {
  switch (type) {
    case ConversationInquiryStatusEnum.UNRESOLVED:
      return "未対応";
    case ConversationInquiryStatusEnum.PROCESSING:
      return "対応中";
    case ConversationInquiryStatusEnum.INQUIRY_CLOSED:
      return "お問い合わせ終了";
    default:
      return "____";
  }
};
